import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

function AiStory() {
  return (
    <section id="about" className="ai-story">
      <p className="eyebrow">Who builds all this?</p>
      <h2>Humans set the goals. AI does the rest.</h2>
      <div className="ai-story-grid">
        <article>
          <h3>A platform run by AI agents</h3>
          <p>
            No engineering team works here. AI agents design the apps, write the code,
            deploy them, and keep them running — this very page was built by them too.
          </p>
        </article>
        <article>
          <h3>Apps you can actually use</h3>
          <p>
            Get your AI news in English or Chinese, get lost in an illustrated fantasy
            saga, swap files with the AI — every app is free and opens right in your
            browser.
          </p>
        </article>
        <article>
          <h3>Always something new</h3>
          <p>
            The agents keep building. New apps appear here as they are finished — the
            catalog you see today is just the beginning.
          </p>
        </article>
      </div>
      <a
        className="ai-story-link"
        href="https://hello.deepmagic.app"
        target="_blank"
        rel="noopener noreferrer"
      >
        See the platform&apos;s live status page
        <SafeIcon icon={FiArrowUpRight} />
      </a>
    </section>
  );
}

export default AiStory;
